import { render } from "./StatsBuilderColItem.vue?vue&type=template&id=279511ae"
import script from "./StatsBuilderColItem.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderColItem.vue?vue&type=script&lang=ts"

import "./StatsBuilderColItem.vue?vue&type=style&index=0&id=279511ae&lang=scss"
script.render = render

export default script